<template>
    <tr :class="`${isEditRequested || isViewDetailsRequested ? 'edit-row' : ''}`">
        <td><EmptyTextHandler :text="familyHealthHistory.Condition" /></td>
        <td><EmptyTextHandler :text="getRelationship()" /></td>
        <td><EmptyTextHandler :text="getAgeOfDiagnosis()" /></td>
        <td><EmptyTextHandler :text="getRelationshipStatuses()" /></td>
        <td class="text-end">
            <div v-if="!isEditRequested && !isDeleteRequested && !isViewDetailsRequested">
                <button class="btn table-btn btn-outline-info" @click="openEditFamilyHistory()" v-if="!isEditRequested">
                    <i class="fas fa-edit"></i>
                </button>
                <button type="button" class="btn table-btn btn-outline-danger" @click="openDeleteRequest()">
                    <i class="fas fa-trash"></i>
                </button>
                <button type="button" class="btn table-btn btn-outline-info" @click="openViewDetails()">
                    View Details
                </button>
            </div>
            <template v-if="currentEditRowId === familyHealthHistory.Id">
                <i v-if="isEditRequested" class="fw-bold">Edit in Progress</i>
                <i v-if="isViewDetailsRequested" class="fw-bold">Viewing Details</i>
            </template>
            <div v-if="isDeleteRequested">
                <TablePrompt
                    ok-text="delete"
                    name="delete"
                    :is-in-progress="isDeleteInProgress"
                    :ok="deleteFamilyHistory"
                    :cancel="closeDeleteRequest"
                />
            </div>
        </td>
    </tr>
    <tr class="edit-row" v-if="isEditRequested">
        <td :colspan="columns" class="p-3 edit">
            <FamilyHistoryForm
                ref="editFamilyHistoryForm"
                :is-save-in-progress="isEditInProgress"
                :family-health-history="cacheFamilyHeathHistory"
                :patient-relationship-enum="patientRelationshipEnum"
                :relation-status-enum="relationStatusEnum"
                :is-edit="true"
                :application="application"
            />
            <div class="text-center">
                <button type="button" class="btn btn-primary btn-md me-2" @click="editFamilyHistory()">Save</button>
                <button type="button" class="btn btn-outline-primary btn-md" @click="cancelEditFamilyHistory()">
                    Cancel
                </button>
            </div>
        </td>
    </tr>
    <tr class="edit-row" v-if="isViewDetailsRequested">
        <td :colspan="columns" class="p-3">
            <div class="d-flex flex-column">
                <table class="table table-responsive-md border border-gray">
                    <thead>
                        <tr class="bg-table-header">
                            <th>Relationship to Patient</th>
                            <th>Age of Diagnosis</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item of familyHealthHistory.PatientRelations">
                            <td>{{ PatientRelationship.getKeyUsingValue(item.RelationshipToPatient) }}</td>
                            <td>{{ item.Age ? item.Age : "N/A" }}</td>
                            <td>{{ item.Status ? RelationStatus.getKeyUsingValue(item.Status) : "N/A" }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="text-center">
                <button type="button" class="btn btn-outline-secondary btn-md ms-2" @click="closeViewDetails()">
                    Close
                </button>
            </div>
        </td>
    </tr>
</template>

<script lang="ts" src="./FamilyHistoryRow.ts" />
